/* jshint esversion: 6 */
import React from 'react';
import { Link } from 'react-router-dom';

class EditSocialHeader extends React.Component {
	render() {
		return (
			<div className="editor-title-bar">
				<span className="editor-title label-left padded">
					<Link to="/config/socials" className="breadcrumb">{this.props.section}</Link>
				</span>
				<i className="fa fa-angle-right editor-title-icon"></i>
				<span className="editor-title label-right">{this.props.action}</span>
				<div className="editor-title-tabs">
					<div className="editor-title-tab tab-active">
						<i className="fa fa-cog"></i> Settings
					</div>
				</div>
			</div>
		);
	}
};

EditSocialHeader.displayName = "EditSocialHeader";

EditSocialHeader.defaultProps = {
	section: '',
	action: ''
};

export default EditSocialHeader;
